import { soundManager } from '../utils/scene/sound/SoundManager'

export const mainSounds = [
  {
    data: {
      name: 'main',
      src: 'audio/main.mp3',
    },
    name: 'main',
    path: 'audio/main.mp3',
  },
]

export const loadSounds = [
  {
    data: {
      name: 'applyCloth',
      src: 'audio/applyCloth.mp3',
    },
    name: 'applyCloth',
    path: 'audio/applyCloth.mp3',
  },
  {
    data: {
      name: 'applyRoom',
      src: 'audio/applyRoom.mp3',
    },
    name: 'applyRoom',
    path: 'audio/applyRoom.mp3',
  },
  {
    data: {
      name: 'buy',
      src: 'audio/buy.mp3',
    },
    name: 'buy',
    path: 'audio/buy.mp3',
  },
  {
    data: {
      name: 'openModal',
      src: 'audio/openModal.mp3',
    },
    name: 'openModal',
    path: 'audio/openModal.mp3',
  },
  {
    data: {
      name: 'startGame',
      src: 'audio/startGame.mp3',
    },
    name: 'startGame',
    path: 'audio/startGame.mp3',
  },
  {
    data: {
      name: 'endGame',
      src: 'audio/endGame.mp3',
    },
    name: 'endGame',
    path: 'audio/endGame.mp3',
  },
  {
    data: {
      name: 'onboarding',
      src: 'audio/onboarding.mp3',
    },
    name: 'onboarding',
    path: 'audio/onboarding.mp3',
  },
  {
    data: {
      name: 'slider',
      src: 'audio/slider.mp3',
    },
    name: 'slider',
    path: 'audio/slider.mp3',
  },
  {
    data: {
      name: 'teeth',
      src: 'audio/teeth.mp3',
    },
    name: 'teeth',
    path: 'audio/teeth.mp3',
  },
  {
    data: {
      name: 'cream',
      src: 'audio/cream.mp3',
    },
    name: 'cream',
    path: 'audio/cream.mp3',
  },
  {
    data: {
      name: 'mask',
      src: 'audio/mask.mp3',
    },
    name: 'mask',
    path: 'audio/mask.mp3',
  },
  {
    data: {
      name: 'foam',
      src: 'audio/foam.mp3',
    },
    name: 'foam',
    path: 'audio/foam.mp3',
  },
  {
    data: {
      name: 'perfume',
      src: 'audio/perfume.mp3',
    },
    name: 'perfume',
    path: 'audio/perfume.mp3',
  },
  {
    data: {
      name: 'perfumeBirkholz',
      src: 'audio/perfume.mp3',
    },
    name: 'perfumeBirkholz',
    path: 'audio/perfume.mp3',
  },
  {
    data: {
      name: 'patches',
      src: 'audio/patches.mp3',
    },
    name: 'patches',
    path: 'audio/patches.mp3',
  },
  {
    data: {
      name: 'serumFace',
      src: 'audio/serumFace.mp3',
    },
    name: 'serumFace',
    path: 'audio/serumFace.mp3',
  },
  {
    data: {
      name: 'creamEyes',
      src: 'audio/creamEyes.mp3',
    },
    name: 'creamEyes',
    path: 'audio/creamEyes.mp3',
  },
  {
    data: {
      name: 'creamFluid',
      src: 'audio/creamFluid.mp3',
    },
    name: 'creamFluid',
    path: 'audio/creamFluid.mp3',
  },
  {
    data: {
      name: 'beforeBeauty',
      src: 'audio/beforeBeauty.mp3',
    },
    name: 'beforeBeauty',
    path: 'audio/beforeBeauty.mp3',
  },
  {
    data: {
      name: 'platformGoodItem',
      src: 'audio/platformGoodItem.mp3',
    },
    name: 'platformGoodItem',
    path: 'audio/platformGoodItem.mp3',
  },
]

export const loadMainSounds = () => soundManager.loadList(mainSounds)
export const loadOtherSounds = () => soundManager.loadList(loadSounds)
